import type { OutwardReferralData } from 'chaika-frontend-types/frontend-cms';
import type { Optional } from 'chaika-common-types';

import { SimpleList } from '@store/models/SimpleList';

import { Money } from '@store/models/Money';
import { translate } from '@chaika/i18n/helper';

export interface OutwardReferralListFilterParams {
    ids?: string[];
    isExecuted?: boolean;
    createdFrom?: Date;
    parentEntryId?: string;
}

export class OutwardReferralList extends SimpleList<OutwardReferralData, OutwardReferralListFilterParams> {
    public static makePriceSting({
        costFrom,
        costTo,
        currency,
    }: Pick<OutwardReferralData, 'costFrom' | 'costTo' | 'currency'>): Optional<string> {
        return !!costFrom
            ? !costTo
                ? `${translate('from').toLowerCase()} ${Money.fromRublesToRublesString(costFrom, currency)}`
                : `${Money.fromRublesToRublesString(costFrom, currency)} - ${Money.fromRublesToRublesString(
                      costFrom,
                      currency,
                  )}`.replace(' ₽', '')
            : !!costTo
              ? `${translate('before').toLowerCase()} ${Money.fromRublesToRublesString(costTo, currency)}`
              : undefined;
    }

    protected filterValue(
        outwardReferral: OutwardReferralData,
        { ids, isExecuted, createdFrom, parentEntryId }: OutwardReferralListFilterParams,
    ): boolean {
        return (
            this.filterFieldValueByArray(outwardReferral, ids, 'id') &&
            this.filterFieldValue(outwardReferral, isExecuted, 'isExecuted') &&
            this.filterFilterValueSameOrAfterFieldValue(outwardReferral, createdFrom, 'createdAt') &&
            this.filterFieldValue(outwardReferral, parentEntryId, 'parentEntryId')
        );
    }
}
